import _ from 'lodash';
import createjs from 'createjs-collection';
import preload from 'preload-js';

import { games } from './../cjsStage';
import * as fJS from './../cjsRoot/fJS';
import { cjsPoint } from './../cjsObjects/cjsPoint';

import STORE from '@/store';

export class base {
  _id;
  _block;
  _layout = {};
  _container;
  _stage;
  _fixTab;
  _points = [];
  _listener = {};

  construct() {
    this._isCorrect = false;
  }

  _setStart(obj) {
    this._id = obj.id;
    this._block = typeof obj.block === 'boolean' ? obj.block : obj.stage.defConfig.itemsConfig.block;
    this._layout = {
      background: {},
      positions: {
        pos: {
          x: _.cloneDeep(obj.stage.defConfig.container.x),
          y: _.cloneDeep(obj.stage.defConfig.container.y),
        },
        padding: _.cloneDeep(obj.stage.defConfig.container.padding),
        margin: _.cloneDeep(obj.stage.defConfig.container.margin),
        rotation: _.cloneDeep(obj.stage.defConfig.container.rotation),
        offset: _.cloneDeep(obj.stage.defConfig.container.offset),
      },
      shadow: {},
    };
    this._stage = obj.stage;
    this._fixTab = [];
  }

  setPropMargin(tmpSets, prop) {
    let obj = _.cloneDeep(this._stage.defConfig.container[prop]);
    for (let i = 0; i < tmpSets.length; i++) {
      if (Object.keys(tmpSets[i]).length > 0) {
        obj = _.merge(obj, tmpSets[i]);
      } else if (fJS.isNumeric(tmpSets[i])) {
        obj = _.merge(obj, {
          top: tmpSets[i],
          left: tmpSets[i],
          right: tmpSets[i],
          bottom: tmpSets[i],
        });
      }
    }

    this[prop] = _.cloneDeep(obj);
  }

  createContainer(bgr, stage) {
    if (this.id === undefined || this.id === null) {
      return this._createCJSContainer(bgr, stage);
    }

    if (this.pos === undefined || this.pos === null) this.pos = {};
    if (!fJS.isNumeric(this.pos.x)) this.pos.x = this._stage.defConfig.container.x;
    if (!fJS.isNumeric(this.pos.y)) this.pos.y = this._stage.defConfig.container.y;

    let pos = {
      x: this.pos && fJS.isNumeric(this.pos.x) ? this.pos.x : this._stage.defConfig.container.x,
      y: this.pos && fJS.isNumeric(this.pos.y) ? this.pos.y : this._stage.defConfig.container.y,
      w: this.pos && fJS.isNumeric(this.pos.width) ? this.pos.width : false,
      h: this.pos && fJS.isNumeric(this.pos.height) ? this.pos.height : false,
      r: this.pos && fJS.isNumeric(this.layout.positions.rotation) ? this.layout.positions.rotation : false,
    };
    let color;
    if (typeof this._layout.background.color === 'string') color = this._layout.background.color;
    else if (Array.isArray(this._layout.background.color)) {
      let idx = 0;
      if (typeof this.idGroup === 'string') {
        idx = Object.keys(this._stage.groups[this.idGroup].items).length - 1;
      } else {
        idx = Object.keys(this._stage.groups).length - 1;
      }
      if (Math.floor(idx / this._layout.background.color.length) > 0) {
        idx -= this._layout.background.color.length * Math.floor(idx / this._layout.background.color.length);
      }
      color = this._layout.background.color[idx];
    }
    let groupBgr = {
      pos: pos,
      name: this.id,
      id: this.id,
      color: color,
      image: this._layout.background.image,
      text: this._layout.background.text,
      border: this._layout.background.border,
      shadow: this._layout.background.shadow,
      block: this._block,
    };

    this._container = this._createCJSContainer(groupBgr, this._stage);
  }

  _createClones(prop) {
    for (let it in this[prop]) {
      //            if ((typeof this[prop][it].otherProperty === 'object' && typeof this[prop][it].otherProperty.clones === 'object' && typeof this[prop][it].otherProperty.clones !== null) || this[prop][it].otherProperty.clones === true) {
      if (
        typeof this[prop][it].otherProperty !== 'object' ||
        this[prop][it].otherProperty === null ||
        typeof this[prop][it].otherProperty.clones !== 'object' ||
        this[prop][it].otherProperty.clones === null
      )
        continue;
      let config = _.cloneDeep(this._stage.defConfig.clones);

      if (this[prop][it].otherProperty.clones !== true) config = _.merge(config, this[prop][it].otherProperty.clones);
      if (!fJS.isNumeric(config.cloneNumber) || config.cloneNumber < 0) throw 'Błędna liczba klonów';

      for (let i = 0, j = 0; i < config.cloneNumber; i++) {
        let c = _.cloneDeepWith(this[prop][it], fJS.customizer);
        c._stage = this._stage;
        delete c._container;
        delete c.otherProperty.clones;
        c._clone = {
          original: { idGroup: this.id, idItem: it },
        };

        if (config.underOriginal === true) {
          c.otherProperty.positionFrom = { idGroup: this.id, idItem: it };
          c._clone.underOriginal = true;
        }

        let name = it + '_' + j;
        c._clone.nrCopy = j;
        while (Object.keys(this[prop]).includes(name)) {
          j++;
          name = it + '_' + j;
          c._clone.nrCopy = j;
        }
        c._idGroup = this.id;
        c.create();
        this.addItem(c, name);
      }
    }
  }

  arrangeItems(prop) {
    let items = [];

    this._createClones(prop);

    for (let it in this[prop]) {
      if (typeof this[prop][it] !== 'object' || this[prop][it] === null || this[prop][it].isAbsolute() === true)
        continue;
      items.push(it);
    }

    if (items.length > 0 && this.shuffle) {
      items = _.shuffle(items);
    }

    let ab = 0,
      grR = [],
      ac = 0,
      pF = [];
    for (let i = 0; i < items.length; i++) {
      let gr = items[i];

      if (
        typeof this[prop][gr].otherProperty.positionFrom === 'object' &&
        this[prop][gr].otherProperty.positionFrom !== null
      ) {
        if (typeof this[prop][gr].clone === 'object' && this[prop][gr].clone !== null) {
          pF.push(gr);
        } else {
          ac = this._setPositionFromAnotherItem(gr, ac);
        }
      } else {
        if (ab < this._fixTab.length) {
          if (!fJS.isNumeric(this._fixTab[ab].x) || !fJS.isNumeric(this._fixTab[ab].y))
            throw 'Błędna konfiguracja tablicy współrzędnych dla grup';
          this[prop][gr].pos.x = this[prop][gr].x = this._fixTab[ab].x;
          this[prop][gr].pos.y = this[prop][gr].y = this._fixTab[ab].y;
          this[prop][gr].type = 'absolute';
          ab++;
        } else {
          grR.push(gr);
        }
      }
    }
    if (ac === 0) {
      if (this.cols <= 0 && this.rows <= 0) {
        this.cols = grR.length;
        this.rows = 1;
      } else if (this.cols > 0) {
        this.cols = grR.length > this.cols ? this.cols : grR.length;
        this.rows = Math.ceil(grR.length / this.cols);
      } else {
        this.rows = grR.length > this.rows ? this.rows : grR.length;
        this.cols = Math.ceil(grR.length / this.rows);
      }
    }

    for (let i = 0, w = 0, c = 0; i < grR.length; i++, c = i % this.cols) {
      let gr = grR[i],
        item = this[prop][gr];
      if (Object.keys(item.margin).length === 0) {
        item.margin = _.cloneDeep(this.margin);
        console.log('MARGIN');
        console.log(this.margin);
      }
      if (Object.keys(item.padding).length === 0) {
        item.padding = _.cloneDeep(this.padding);
        console.log('PADDING');
        console.log(this.padding);
      }

      if (i === 0) {
        item.pos.x = item.pos && fJS.isNumeric(item.pos.x) ? item.pos.x : this._stage.defConfig.container.x;
        item.pos.y = item.pos && fJS.isNumeric(item.pos.y) ? item.pos.y : this._stage.defConfig.container.y;
      } else {
        if (c === 0) {
          w++;
          item.pos.x = this[prop][grR[i - this.cols]].pos.x - this[prop][grR[i - this.cols]].margin.left;
          item.pos.y =
            this[prop][grR[i - this.cols]].pos.y +
            this[prop][grR[i - this.cols]].height -
            this[prop][grR[i - this.cols]].margin.bottom;
        } else {
          item.pos.x =
            this[prop][grR[i - 1]].pos.x + this[prop][grR[i - 1]].width + this[prop][grR[i - 1]].margin.right;
          if (w === 0)
            item.pos.y =
              this[prop][grR[i - 1]].pos.y -
              this[prop][grR[i - 1]].margin.top -
              (i - this.cols - 1 >= 0 ? this[prop][grR[i - this.cols - 1]].margin.bottom : 0);
          else
            item.pos.y =
              this[prop][grR[i - this.cols]].pos.y +
              this[prop][grR[i - this.cols]].height -
              (i - this.cols - 1 >= 0 ? this[prop][grR[i - this.cols - 1]].margin.bottom : 0);
        }
      }

      item.pos.x += item.margin.left;
      item.pos.y += item.margin.top + (i - this.cols >= 0 ? this[prop][grR[i - this.cols]].margin.bottom : 0);

      if (c === 0) item.pos.x += this.padding.left;
      else if (c > 0 && w === 0) item.pos.y -= this.padding.top;

      if (w === 0) item.pos.y += this.padding.top;
      else if (w > 0 && c === 0) item.pos.x -= this.padding.left;
    }

    for (let i = 0, w = 0, c = 0; i < grR.length; i++, c = i % this.cols) {
      let gr = grR[i],
        item = this[prop][gr];
      if (i > 0 && c === 0) {
        w++;
      }
      if (this._offsetItems !== undefined && this._offsetItems !== null)
        this._offsetItems.forEach(function(off) {
          if (
            (!fJS.isNumeric(off.row) || (fJS.isNumeric(off.row) && w === off.row)) &&
            (!fJS.isNumeric(off.column) || (fJS.isNumeric(off.column) && c === off.column))
          ) {
            item.pos.x += off.x;
            item.offset.x = off.x;
            item.pos.y += off.y;
            item.offset.y = off.y;
          }
        });
      item.x = item.pos.x;
      item.y = item.pos.y;
    }

    // console.log(this.layout.positions);

    if (this.autoFit === true) {
      let mX = false,
        mY = false,
        iW = 0,
        iH = 0;
      for (let it in this[prop]) {
        if (mX === false || mX < this[prop][it].x) {
          mX = this[prop][it].x;
          iW = this[prop][it].width + this[prop][it].margin.right;
        }
        if (mY === false || mY < this[prop][it].y) {
          mY = this[prop][it].y;
          iH = this[prop][it].height + this[prop][it].margin.bottom;
        }
      }

      this.pos.width = fJS.isNumeric(this.pos.width) ? this.pos.width : mX + iW + this.padding.right;
      this.pos.height = fJS.isNumeric(this.pos.height) ? this.pos.height : mY + iH + this.padding.bottom;
    }

    if (pF.length > 0) {
      for (let i = 0; i < pF.length; i++) {
        this._setPositionFromAnotherItem(pF[i], i, true);
      }
    }

    for (let i in this[prop]) {
      this[prop][i]._posStart = _.cloneDeep(this[prop][i].pos);
    }
  }

  _createCJSContainer(obj, stage) {
    let container = new createjs.Container(),
      shadow = null;
    obj.block = typeof obj.block === 'boolean' ? obj.block : stage.defConfig.itemsConfig.block;
    container.x = obj.pos !== undefined && fJS.isNumeric(obj.pos.x) ? obj.pos.x : stage.defConfig.container.x;
    container.y = obj.pos !== undefined && fJS.isNumeric(obj.pos.y) ? obj.pos.y : stage.defConfig.container.y;
    container.width = obj.pos !== undefined && fJS.isNumeric(obj.pos.w) ? obj.pos.w : stage.defConfig.container.width;
    container.height = obj.pos !== undefined && fJS.isNumeric(obj.pos.h) ? obj.pos.h : stage.defConfig.container.height;

    if (obj.name) container.name = obj.name;
    if (obj.id) container.name = obj.id;

    if (obj.shadow) {
      shadow = new createjs.Shadow(
        obj.shadow.color ? obj.shadow.color : stage.defConfig.shadow.color,
        obj.shadow.offsetX !== undefined && fJS.isNumeric(obj.shadow.offsetX)
          ? obj.shadow.offsetX
          : stage.defConfig.shadow.offset.x,
        obj.shadow.offsetY !== undefined && fJS.isNumeric(obj.shadow.offsetY)
          ? obj.shadow.offsetY
          : stage.defConfig.shadow.offset.y,
        obj.shadow.blur !== undefined && fJS.isNumeric(obj.shadow.blur) ? obj.shadow.blur : stage.defConfig.shadow.blur
      );
    }

    if (obj.color) {
      let shape = this._createShape(
        {
          name: 'shape-bgr-color',
          width: container.width,
          height: container.height,
          color: obj.color,
          border: obj.border,
          id: obj.id,
          block: obj.block,
        },
        stage
      );
      if (shadow !== null) shape.shadow = shadow;
      container.addChild(shape);
    }
    let store = STORE;
    let multibookType = store.getters.multibookType;
    if (obj.image && obj.image.src && obj.image.src.length > 0) {
      obj.image.block = obj.block;
      if (typeof obj.image.pos !== 'object' || obj.image.pos === null) obj.image.pos = { x: 0, y: 0 };
      // obj.image.src = obj.image.src.replace('static/games/', `static/${multibookType}/games/`);
      let test = obj.image.src.replace('static/games/', `games/`);
      if (!_.includes(test, `static/${multibookType}/games`)) {
        if (_.includes(test, 'games/page')) {
          obj.image.src = require(`__staticDir/${multibookType}/${test}`);
        }
      }
      this._addImage(obj.image, stage, container, obj.id, shadow);
    }

    if (obj.text !== null && obj.text !== undefined && typeof obj.text.val === 'string') {
      let txt = obj.text.val.split(new RegExp('__', 'i')).remove('');
      let t = this._createTxt(
        {
          id: obj.id,
          text: obj.text,
          width: container.width,
          height: container.height,
          block: obj.block,
        },
        stage
      );

      if (txt.length === 1) {
        if (this._layout.positions.autoFit === true) {
          this._redrawShape(container, obj, {
            x: t.x,
            y: t.y,
            width: t.width,
            height: t.height,
          });
          container.addChild(
            this._createTxt(
              {
                id: obj.id,
                text: obj.text,
                width: container.width,
                height: container.height,
                block: obj.block,
              },
              stage
            )
          );
        } else {
          container.addChild(t);
        }
      } else {
        let w = 0,
          h = 0,
          x = t.x,
          y = false,
          yh = false,
          br = 0,
          nTxt = [],
          isCenter = false;

        for (let i = 0; i < txt.length; i++) {
          if (typeof this.hooks[txt[i]] !== 'object' || this.hooks[txt[i]] === null) {
            let op = _.cloneDeep(obj.text);
            op.val = txt[i].replace('\n', '');
            let g = this._createTxt({ id: obj.id, text: op, width: 0, height: 0, block: obj.block }, stage);
            nTxt[i] = g;
            br = br === 0 && !fJS.isNumeric(op.lineHeight) ? g.height : op.lineHeight;
          } else {
            br = br < this.hooks[txt[i]].height ? this.hooks[txt[i]].height : br;
            if (yh === false) {
              if ((fJS.isNumeric(obj.text.lineHeight) ? obj.text.lineHeight : stage.defConfig.text.lineHeight) === 0)
                yh = 0;
              else
                yh =
                  ((fJS.isNumeric(obj.text.lineHeight) ? obj.text.lineHeight : stage.defConfig.text.lineHeight) -
                    this.hooks[txt[i]].height) /
                  2;
            }
          }
        }

        if (obj.text.textBaseline === 'middle') y = br / 2;
        let newLine = false,
          inLine = false;
        for (let i = 0; i < txt.length; i++) {
          if (typeof this.hooks[txt[i]] === 'object' && this.hooks[txt[i]] !== null) {
            if (newLine === false && inLine === false && container.children.length > 0)
              x += container.getChildAt(container.children.length - 1).width;
            this.hooks[txt[i]].x = x + this.hooks[txt[i]].layout.positions.offset.x;
            this.hooks[txt[i]].y = yh + this.hooks[txt[i]].layout.positions.offset.y;
            x += this.hooks[txt[i]].width + this.hooks[txt[i]].layout.positions.offset.x;
          } else {
            if (/\n/g.test(txt[i]) === true) {
              inLine = false;
              let ln = txt[i].split(new RegExp('\n', 'g')).remove('');
              if (txt[i].indexOf('\n') === 0) {
                x = t.x;
                y += br;
                yh += br;
              }
              newLine = /\n$/.test(txt[i]);
              for (let j = 0; j < ln.length; j++) {
                let op = _.cloneDeep(obj.text);
                op.val = ln[j];
                let g = this._createTxt(
                  {
                    id: obj.id,
                    text: op,
                    width: 0,
                    height: 0,
                    block: obj.block,
                  },
                  stage
                );
                g.x = x;
                g.y = y;
                x += g.width;
                w = w < x ? x : w;
                container.addChild(g);
                x = t.x;

                if (j === ln.length - 1 && newLine === false) continue;
                y += br;
                yh += br;
              }
            } else {
              inLine = true;
              nTxt[i].x = x;
              nTxt[i].y = y;
              x += nTxt[i].width;
              container.addChild(nTxt[i]);
            }
          }

          h = h < y ? y : h;
          w = w < x ? x : w;
        }

        if (obj.text.textBaseline === 'middle') h += br / 2;
        if (this._layout.positions.autoFit === true) {
          this._redrawShape(container, obj, {
            x: 0,
            y: 0,
            width: w + t.x,
            height: h,
          });
        }
      }
    }

    if (obj.block !== true) {
      container.listener = {
        md: container.on('mousedown', this.stageMouseDown, null, false, {
          engine: this,
          cjsStage: stage,
        }),
        pu: container.on('pressup', this.stageMouseUp, null, false, {
          engine: this,
          cjsStage: stage,
        }),
      };
    }
    // console.log(obj);
    //    container.rotation = (obj.pos !== undefined && fJS.isNumeric(obj.pos.r)) ? obj.pos.r : stage.defConfig.container.rotation;
    return container;
  }

  stageMouseDown(e, data) {
    console.log('base: DOWN');
    e.stopPropagation();
  }

  stageMouseUp(e, data) {
    console.log('base: UP');
    e.stopPropagation();
  }

  _createShape(obj, stage) {
    let shape = new createjs.Shape();
    shape.name = obj.name;
    shape.width = obj.width;
    shape.height = obj.height;
    if (obj.border && obj.border.color != 'transparent') {
      shape.graphics
        .ss(fJS.isNumeric(obj.border.size) ? obj.border.size : 1)
        .s(obj.border.color)
        .f(obj.color)
        .dr(0, 0, shape.width, shape.height).command;
    } else
      shape.graphics
        .f(obj.color)
        .dr(0, 0, shape.width, shape.height)
        .ef();
    if (obj.id) shape.id = obj.id;

    if (obj.pos) {
      shape.x = fJS.isNumeric(obj.pos.x) ? obj.pos.x : 0;
      shape.y = fJS.isNumeric(obj.pos.y) ? obj.pos.y : 0;
    }
    if (obj.block !== true) {
      shape.listener = {
        md: shape.on('mousedown', this.stageMouseDown, null, false, {
          engine: this,
          cjsStage: stage,
        }),
        pu: shape.on('pressup', this.stageMouseUp, null, false, {
          engine: this,
          cjsStage: stage,
        }),
      };
    }
    //    obj.image.block = (typeof obj.block === 'boolean') ? obj.block : stage.defConfig.itemsConfig.block;
    return shape;
  }

  _redrawShape(container, obj, pos) {
    container.width = pos.width + pos.x * 2;
    container.height = pos.height + pos.y;

    let sh = container.getChildByName('shape-bgr-color');
    if (sh === null) {
      return false;
    }
    sh.graphics.c();
    if (obj.border && obj.border != 'transparent') {
      sh.graphics.ss(obj.border.size).s(obj.border.color);
    }
    sh.graphics
      .f(obj.color)
      .dr(0, 0, pos.width + pos.x * 2, pos.height + pos.y)
      .ef();
  }

  _addImage(image, stage, container, id, shadow) {
    var self = this;
    stage.promises.push(
      new Promise((resolve, reject) => {
        let queue = new preload.LoadQueue();
        queue.on('fileload', function(e) {
          let bmp = new createjs.Bitmap(e.result.src);

          if (id) bmp.id = id;
          if (image.pos !== undefined) {
            if (fJS.isNumeric(image.pos.width)) {
              bmp.scaleX = image.pos.width / e.result.width;
              if (!fJS.isNumeric(image.pos.height)) bmp.scaleY = bmp.scaleX;
            }
            if (fJS.isNumeric(image.pos.height)) {
              bmp.scaleY = image.pos.height / e.result.height;
              if (!fJS.isNumeric(image.pos.width)) bmp.scaleX = bmp.scaleY;
            }

            if (fJS.isNumeric(image.pos.x)) bmp.x = image.pos.x;
            if (fJS.isNumeric(image.pos.y)) bmp.y = image.pos.y;
          }

          if (this.block !== true && image.block !== true) {
            bmp.listener = {
              md: bmp.on('mousedown', self.stageMouseDown, null, false, {
                engine: self,
                cjsStage: stage,
              }),
              pu: bmp.on('pressup', self.stageMouseUp, null, false, {
                engine: self,
                cjsStage: stage,
              }),
            };
          }
          if (typeof container !== 'object' || container === null) return false;

          let bgr = container.getChildByName('shape-bgr-color');
          let border;
          if (image.border) {
            console.log('IMAGE SIZE');
            console.log(
              'width: ' +
                (fJS.isNumeric(image.pos.width)
                  ? image.pos.width
                  : fJS.isNumeric(bmp.width)
                  ? bmp.width
                  : fJS.isNumeric(bmp.image.width)
                  ? bmp.image.width
                  : fJS.isNumeric(bmp.getBounds().width)
                  ? bmp.getBounds().width
                  : 0) +
                ' height: ' +
                (fJS.isNumeric(image.pos.height)
                  ? image.pos.height
                  : fJS.isNumeric(bmp.height)
                  ? bmp.height
                  : fJS.isNumeric(bmp.image.height)
                  ? bmp.image.height
                  : fJS.isNumeric(bmp.getBounds().height)
                  ? bmp.getBounds().height
                  : 0)
            );
            border = self._createShape(
              {
                pos: image.pos,
                width: fJS.isNumeric(image.pos.width)
                  ? image.pos.width
                  : fJS.isNumeric(bmp.width)
                  ? bmp.width
                  : fJS.isNumeric(bmp.image.width)
                  ? bmp.image.width
                  : fJS.isNumeric(bmp.getBounds().width)
                  ? bmp.getBounds().width
                  : 0,
                height: fJS.isNumeric(image.pos.height)
                  ? image.pos.height
                  : fJS.isNumeric(bmp.height)
                  ? bmp.height
                  : fJS.isNumeric(bmp.image.height)
                  ? bmp.image.height
                  : fJS.isNumeric(bmp.getBounds().height)
                  ? bmp.getBounds().height
                  : 0,
                color: 'transparent',
                border: image.border,
                id: bmp.id,
              },
              stage
            );
          }
          if (bgr !== null) {
            if (border) {
              container.addChildAt(border, container.getChildIndex(bgr) + 1);
            }
            container.addChildAt(bmp, container.getChildIndex(bgr) + 1);
          } else {
            let idx = 0;
            if (border) {
              container.addChildAt(border, idx);
              idx++;
            }
            container.addChildAt(bmp, idx);
          }
        });

        queue.on('complete', function(e) {
          resolve(self);
        });
        // queue.loadManifest([{ src: `./../../../../../${image.src}` }]);
        // console.log(image.src);
        queue.loadManifest([{ src: image.src }]);
      })
    );
  }

  _createTxt2(obj, stage) {
    var html = document.createElement('div');
    html.innerHTML = obj.text.val;

    /*
         * text.font += ((obj.text.italic === true) || (typeof obj.text.italic !== 'boolean' && stage.defConfig.text.italic === true)) ? ' italic ' : '';
         text.font += ((obj.text.size) ? obj.text.size : stage.defConfig.text.size) + ' ';
         text.font += ((obj.text.font) ? obj.text.font : stage.defConfig.text.font);
         text.color = ((obj.text.color) ? obj.text.color : stage.defConfig.text.color);
         text.textBaseline = (typeof obj.text.textBaseline === 'string') ? obj.text.textBaseline : stage.defConfig.text.textBaseline;
         text.textAlign = (typeof obj.text.textAlign === 'string') ? obj.text.textAlign : stage.defConfig.text.textAlign;
         text.lineHeight = (fJS.isNumeric(obj.text.lineHeight)) ? obj.text.lineHeight : stage.defConfig.text.lineHeight;
         text.lineWidth = (fJS.isNumeric(obj.text.lineWidth)) ? obj.text.lineWidth : stage.defConfig.text.lineWidth;
         */
    let css = {};
    if (obj.text.bold === true) css['font-weight'] = 'bold';
    stage.setPropertyStyle(html, _.merge(css, stage._mixins.getCustomStyle(obj.text)));

    document.getElementById('cjsTxts').appendChild(html);

    let text = new createjs.DOMElement(html);
    //   gg.x = ((typeof this.config.mainText.positions === 'object' && fJS.isNumeric(this.config.mainText.positions.x)) ? this.config.mainText.positions.x : 0) - this.offset.x;
    //   gg.y = ((typeof this.config.mainText.positions === 'object' && fJS.isNumeric(this.config.mainText.positions.y)) ? this.config.mainText.positions.y : 0) - this.offset.y;
    //   if (typeof this.config.mainText.positions === 'object' && fJS.isNumeric(this.config.mainText.positions.width) && this.config.mainText.positions.width > 0) gg.width = this.config.mainText.positions.width;
    //   if (typeof this.config.mainText.positions === 'object' && fJS.isNumeric(this.config.mainText.positions.height) && this.config.mainText.positions.height > 0) gg.height = this.config.mainText.positions.height;

    text.x += typeof obj.text.offset === 'object' && fJS.isNumeric(obj.text.offset.x) ? obj.text.offset.x : 0;
    text.y += typeof obj.text.offset === 'object' && fJS.isNumeric(obj.text.offset.y) ? obj.text.offset.y : 0;

    //  text.width = text.getBounds().width;
    //  text.height = text.getBounds().height;

    if (obj.block !== true) {
      text.listener = {
        md: text.on('mousedown', this.stageMouseDown, null, false, {
          engine: this,
          cjsStage: stage,
        }),
        pu: text.on('pressup', this.stageMouseUp, null, false, {
          engine: this,
          cjsStage: stage,
        }),
      };
    }

    return text;
  }

  _createTxt(obj, stage) {
    var text = new createjs.Text();
    if (obj.id) text.id = obj.id;
    text.text = obj.text.val;
    text.font =
      obj.text.bold === true || (typeof obj.text.bold !== 'boolean' && stage.defConfig.text.bold === true)
        ? 'bold '
        : '';
    text.font +=
      obj.text.italic === true || (typeof obj.text.italic !== 'boolean' && stage.defConfig.text.italic === true)
        ? ' italic '
        : '';
    text.font += (obj.text.size ? obj.text.size : stage.defConfig.text.size) + ' ';
    text.font += obj.text.font ? obj.text.font : stage.defConfig.text.font;
    text.color = obj.text.color ? obj.text.color : stage.defConfig.text.color;
    text.textBaseline =
      typeof obj.text.textBaseline === 'string' ? obj.text.textBaseline : stage.defConfig.text.textBaseline;
    text.textAlign = typeof obj.text.textAlign === 'string' ? obj.text.textAlign : stage.defConfig.text.textAlign;
    text.lineHeight = fJS.isNumeric(obj.text.lineHeight) ? obj.text.lineHeight : stage.defConfig.text.lineHeight;
    text.lineWidth = fJS.isNumeric(obj.text.lineWidth) ? obj.text.lineWidth : stage.defConfig.text.lineWidth;

    if ((obj.text.pos && fJS.isNumeric(obj.text.pos.x)) || fJS.isNumeric(stage.defConfig.text.pos.x)) {
      text.x = obj.text.pos && fJS.isNumeric(obj.text.pos.x) ? obj.text.pos.x : stage.defConfig.text.pos.x;
    } else if (obj.width > 0) {
      if (text.textAlign == 'center') text.x = obj.width / 2;
      else if (text.textAlign == 'right' || text.textAlign == 'end') text.x = obj.width;
    }

    if ((obj.text.pos && fJS.isNumeric(obj.text.pos.y)) || fJS.isNumeric(stage.defConfig.text.pos.y)) {
      text.y = obj.text.pos && fJS.isNumeric(obj.text.pos.y) ? obj.text.pos.y : stage.defConfig.text.pos.y;
    } else if (obj.height > 0) {
      if (text.textBaseline == 'middle') {
        text.y = obj.height / 2;
      } else if (text.textBaseline == 'bottom') {
        text.y = obj.height;
      }
    }

    text.x += typeof obj.text.offset === 'object' && fJS.isNumeric(obj.text.offset.x) ? obj.text.offset.x : 0;
    text.y += typeof obj.text.offset === 'object' && fJS.isNumeric(obj.text.offset.y) ? obj.text.offset.y : 0;

    text.width = text.getBounds().width;
    text.height = text.getBounds().height;

    if (obj.block !== true) {
      text.listener = {
        md: text.on('mousedown', this.stageMouseDown, null, false, {
          engine: this,
          cjsStage: stage,
        }),
        pu: text.on('pressup', this.stageMouseUp, null, false, {
          engine: this,
          cjsStage: stage,
        }),
      };
    }

    return text;
  }

  _addPoint(point) {
    if (point.block !== true) {
      point._listener.md = point.shape.on('mousedown', this.pointMouseDown, null, false, {
        engine: this,
        idPoint: point.id,
        cjsStage: this._stage,
      });
      point._listener.pu = point.shape.on('pressup', this.pointMouseUp, null, false, {
        engine: this,
        idPoint: point.id,
        cjsStage: this._stage,
      });
    }
    this._points[point.id] = point;
    this._container.addChildAt(point.shape, this._container.numChildren === 0 ? 0 : this._container.numChildren - 1);
  }

  isEqual(obj1, obj2, checkOnlyLeft) {
    let equal = true;
    for (let i in obj1) {
      equal = obj1[i] !== obj2[i] ? false : equal;
    }
    if (checkOnlyLeft === true) return equal;
    for (let i in obj2) {
      equal = obj1[i] !== obj2[i] ? false : equal;
    }
    return equal;
  }

  isAbsolute() {
    return typeof this._layout.positions.type === 'string' && this._layout.positions.type.toLowerCase() === 'absolute';
  }

  pointMouseDown(e, data) {
    console.log('POINT DOWN');
  }

  pointMouseUp(e, data) {
    console.log('POINT UP');
  }

  get id() {
    return this._id;
  }
  get block() {
    return this._block;
  }
  set block(v) {
    if (typeof v !== 'boolean') throw 'Wartość blokowania elementu: ' + this.id + ' jest inne niż boolean';
    this._block = v;
  }
  get layout() {
    return this._layout;
  }
  get container() {
    return this._container;
  }
  get width() {
    return this._container.width;
  }
  get height() {
    return this._container.height;
  }
  get autoFit() {
    if (fJS.isNumeric(this.pos.width) && fJS.isNumeric(this.pos.height)) return false;
    if (
      typeof this._layout !== 'object' ||
      this._layout === null ||
      typeof this._layout.positions !== 'object' ||
      this._layout.positions === null ||
      typeof this._layout.positions.autoFit !== 'boolean'
    )
      return this._stage.defConfig.container.autoFit;
    return this._layout.positions.autoFit;
  }

  get margin() {
    return this._layout.positions.margin;
  }
  set margin(v) {
    this._layout.positions.margin = v;
  }
  get padding() {
    return this._layout.positions.padding;
  }
  set padding(v) {
    this._layout.positions.padding = v;
  }
  get offset() {
    return this._layout.positions.offset;
  }
  set offset(v) {
    this._layout.positions.offset = v;
  }
  get pos() {
    return this._layout.positions.pos;
  }
  set pos(v) {
    this._layout.positions.pos = v;
  }
  set type(v) {
    this._layout.positions.type = v;
  }

  set x(v) {
    if (!fJS.isNumeric(v)) throw 'Nieprawidłowa wartość współrzędnej x dla: ' + this.id;
    this._container.x = v;
  }
  get x() {
    return this._container.x;
  }
  set y(v) {
    if (!fJS.isNumeric(v)) throw 'Nieprawidłowa wartość współrzędnej y dla: ' + this.id;
    this._container.y = v;
  }
  get y() {
    return this._container.y;
  }
  set points(v) {
    this._points = v;
  }
  get points() {
    return this._points;
  }
  set regX(v) {
    this._container.regX = v;
  }
  get regX() {
    return this._container.regX;
  }
  set regY(v) {
    this._container.regY = v;
  }
  get regY() {
    return this._container.regY;
  }
  set rotation(v) {
    this._container.rotation = v;
  }
  get rotation() {
    return this._container.rotation;
  }
  get clone() {
    return this._clone;
  }
  get isClone() {
    return typeof this._clone === 'object' && this._clone !== null;
  }
}

export class cjsItem extends base {
  _otherProperty;
  _correct;
  _idGroup;
  _posStart;
  _isCorrect;
  _sounds;

  constructor(obj) {
    super();
    this._idGroup = obj.idGroup;
    this._setStart(obj);
    this._otherProperty = {};
    this._correct = obj.correct;
    this._isCorrect = false;
    this._sounds = {};
  }

  create() {
    this.createContainer();
    if (typeof this._otherProperty.vue === 'object' && this._otherProperty.vue !== null) {
      this.createVue();
    }
    if (
      (typeof this._otherProperty.audio === 'string' || Array.isArray(this._otherProperty.audio)) &&
      this._otherProperty.audio.length > 0
    ) {
      this.createAudio();
    }
    if (Array.isArray(this._otherProperty.sounds) === true && this._otherProperty.sounds.length > 0) {
      this.createSounds();
    }
  }

  createVue() {
    for (const key in this._otherProperty.vue) {
      let ids = [];
      if (typeof this._otherProperty.vue[key] === 'string' && this._otherProperty.vue[key].length > 0) {
        ids.push(this._otherProperty.vue[key]);
      } else if (Array.isArray(this._otherProperty.vue[key])) {
        ids = _.cloneDeep(this._otherProperty.vue[key]);
      } else {
        throw 'W grupie ' + this._idGroup + ' element ' + this._id + ' ma zły typ ID elementu drzewa DOM';
      }

      for (let i = 0; i < ids.length; i++) {
        if (typeof ids[i] !== 'string' || ids[i].length === 0) {
          throw 'W grupie ' + this._idGroup + ' element ' + this._id + ' ma zły typ ID elementu drzewa DOM';
        }
        let vue = document.getElementById(ids[i]);
        if (vue === null) {
          throw 'Nie ma w drzewie DOM elementu o id ' +
            ids[i] +
            ' skonfigurowany w grupie ' +
            this._idGroup +
            ' w elemencie: ' +
            this._id;
        }

        vue.style.zIndex = '1';
        let html = new createjs.DOMElement(vue);
        this._container.addChild(html);
      }
    }
  }

  createAudio() {
    let ids = [];
    if (typeof this._otherProperty.audio === 'string' && this._otherProperty.audio.length > 0) {
      ids.push(this._otherProperty.audio);
    } else if (Array.isArray(this._otherProperty.audio)) {
      ids = _.cloneDeep(this._otherProperty.audio);
    } else {
      throw 'W grupie ' + this._idGroup + ' element ' + this._id + ' ma zły typ ID elementu drzewa DOM';
    }

    for (let i = 0; i < ids.length; i++) {
      if (typeof ids[i] !== 'string' || ids[i].length === 0) {
        throw 'W grupie ' + this._idGroup + ' element ' + this._id + ' ma zły typ ID elementu drzewa DOM';
      }
      let audio = document.getElementById(ids[i]);
      if (audio === null) {
        throw 'Nie ma w drzewie DOM elementu o id ' +
          ids[i] +
          ' skonfigurowany w grupie ' +
          this._idGroup +
          ' w elemencie: ' +
          this._id;
      }

      audio.style.zIndex = '1';
      let html = new createjs.DOMElement(audio);
      this._container.addChild(html);
    }
  }

  createSounds() {
    let store = STORE;
    let multibookType = store.getters.multibookType;
    let manifest = [];

    for (let i in this._otherProperty.sounds) {
      if (typeof this._otherProperty.sounds[i] !== 'object' || typeof this._otherProperty.sounds[i] === null) {
        continue;
      }
      let audio = _.cloneDeep(this._otherProperty.sounds[i]);
      audio.id = this.idGroup + '.' + this.id + '.' + this._otherProperty.sounds[i].id;
      let test = audio.src.replace('static/games/', `games/`);
      if (!_.includes(test, `static/${multibookType}/games`)) {
        if (_.includes(test, 'games/page')) {
          audio.src = require(`__staticDir/${multibookType}/${test}`);
        }
      }

      manifest.push(audio);
    }
    let queue = new createjs.LoadQueue(),
      self = this;
    queue.installPlugin(this._stage.sounds.Sound);
    queue.addEventListener('error', function(event) {
      console.log('ERROR LOADS MP3');
      console.log(event);
    });
    queue.loadManifest(manifest);
  }

  setLayout(prop, sets, layoutGroup, layoutItem, rules) {
    //    if (this.id === 'hr' && prop === 'positions') console.log(JSON.stringify(this._layout[prop]));
    this._layout[prop] = _.merge(
      this._layout[prop],
      // sets: config.layout.itemsConfig.background
      sets && typeof sets.layout.itemsConfig[prop] === 'object' && sets.layout.itemsConfig[prop] !== null
        ? sets.layout.itemsConfig[prop]
        : null,
      // config.layout.groups[x].itemsConfig.background
      layoutGroup.itemsConfig &&
        typeof layoutGroup.itemsConfig[prop] === 'object' &&
        layoutGroup.itemsConfig[prop] !== null
        ? _.cloneDeep(layoutGroup.itemsConfig[prop])
        : null,
      // config.layout.groups[x].items[y].background
      typeof layoutItem[prop] === 'object' && layoutItem[prop] !== null ? _.cloneDeep(layoutItem[prop]) : null,
      // rulesGame.itemsConfig.background
      sets &&
        typeof sets.rules.itemsConfig === 'object' &&
        typeof sets.rules.itemsConfig[prop] === 'object' &&
        sets.rules.itemsConfig[prop] !== null
        ? _.cloneDeep(sets.rules.itemsConfig[prop])
        : null,
      // rulesGame.items[x].itemsConfig
      rules &&
        typeof rules.itemsConfig === 'object' &&
        typeof rules.itemsConfig[prop] === 'object' &&
        rules.itemsConfig[prop] !== null
        ? _.cloneDeep(rules.itemsConfig[prop])
        : null
    );
  }

  setMargin(prop, sets, layoutGroup, layoutItem, rules) {
    let tmpSets = [
      typeof sets === 'object' &&
      typeof sets.layout === 'object' &&
      sets.layout.itemsConfig &&
      typeof sets.layout.itemsConfig.positions === 'object' &&
      sets.layout.itemsConfig.positions[prop] !== undefined &&
      sets.layout.itemsConfig.positions[prop] !== null
        ? sets.layout.itemsConfig.positions[prop]
        : {},
      layoutGroup.itemsConfig &&
      typeof layoutGroup.itemsConfig.positions === 'object' &&
      layoutGroup.itemsConfig.positions[prop] !== undefined &&
      layoutGroup.itemsConfig.positions[prop] !== null
        ? layoutGroup.itemsConfig.positions[prop]
        : {},
      typeof layoutItem.positions === 'object' &&
      layoutItem.positions[prop] !== undefined &&
      layoutItem.positions[prop] !== null
        ? layoutItem.positions[prop]
        : {},
      typeof sets === 'object' &&
      typeof sets.rules === 'object' &&
      sets.rules.itemsConfig &&
      typeof sets.rules.itemsConfig.positions === 'object' &&
      sets.rules.itemsConfig.positions[prop] !== undefined &&
      sets.rules.itemsConfig.positions[prop] !== null
        ? sets.rules.itemsConfig.positions[prop]
        : {},
      typeof rules === 'object' &&
      rules !== null &&
      rules.itemsConfig &&
      typeof rules.itemsConfig.positions === 'object' &&
      rules.itemsConfig.positions[prop] !== undefined &&
      rules.itemsConfig.positions[prop] !== null
        ? rules.itemsConfig.positions[prop]
        : {},
    ];

    this.setPropMargin(tmpSets, prop);
  }

  setOtherProperty(idGroup, sets, layoutGroup, layoutItem, rules) {
    this._setOtherProperty = _.merge(
      this._otherProperty,
      sets && typeof sets.otherProperty === 'object' && sets.otherProperty !== null ? sets.otherProperty : {},
      typeof layoutGroup.otherProperty === 'object' && layoutGroup.otherProperty !== null
        ? _.cloneDeep(layoutGroup.otherProperty)
        : {},
      typeof layoutItem.otherProperty === 'object' && layoutItem.otherProperty !== null
        ? _.cloneDeep(layoutItem.otherProperty)
        : {},
      sets && typeof sets.rules.otherProperty === 'object' && sets.rules.otherProperty !== null
        ? _.cloneDeep(sets.rules.otherProperty)
        : {},
      rules && rules.otherProperty && typeof rules.otherProperty === 'object' && rules.otherProperty !== null
        ? _.cloneDeep(rules.otherProperty)
        : {}
    );
  }

  get otherProperty() {
    return this._otherProperty;
  }
  get correct() {
    return this._correct;
  }
  get idGroup() {
    return this._idGroup;
  }

  get posStart() {
    return this._posStart;
  }
  get isCorrect() {
    return this._isCorrect;
  }
  set isCorrect(v) {
    this._isCorrect = v;
  }

  stageMouseDown(e, data) {
    console.log(this.id + ' cjsItem: DOWN');
    e.stopPropagation();
  }

  stageMouseUp(e, data) {
    console.log(this.id + ' cjsItem: UP');
    let engine = data.engine;
    if (engine._container.cacheID !== 0) engine._container.updateCache();
    e.stopPropagation();
  }
}

cjsItem.afterLoadSamples = function(stage) {
  console.log('afterLoadSamples');
  for (let gr in stage.groups) {
    for (let i in stage.groups[gr].items) {
      let item = stage.groups[gr].items[i];

      if (item.isClone === true && item._clone.underOriginal === true) {
        stage.groups[gr].items[i]._posStart = _.cloneDeep(
          stage.groups[item.clone.original.idGroup].items[item.clone.original.idItem].posStart
        );
        stage.groups[gr].items[i].x = stage.groups[gr].items[i].pos.x = _.cloneDeep(
          stage.groups[gr].items[i]._posStart.x
        );
        stage.groups[gr].items[i].y = stage.groups[gr].items[i].pos.y = _.cloneDeep(
          stage.groups[gr].items[i]._posStart.y
        );
      }

      if (typeof item.otherProperty.points === 'object' && item.otherProperty.points !== null) {
        if (typeof stage.mousePoint !== 'object' || stage.mousePoint === null) {
          stage.mousePoint = new cjsPoint({
            alwaysShow:
              typeof item.otherProperty.points.pointMouse === 'object' &&
              typeof item.otherProperty.points.pointMouse.alwaysShow === 'boolean'
                ? item.otherProperty.points.pointMouse.alwaysShow
                : stage.defConfig.point.alwaysShow,
            name: 'mousePoint',
            color:
              typeof item.otherProperty.points.pointMouse === 'object' &&
              typeof item.otherProperty.points.pointMouse.color === 'string'
                ? item.otherProperty.points.pointMouse.color
                : stage.defConfig.point.color,
            image:
              typeof item.otherProperty.points.pointMouse === 'object' &&
              typeof item.otherProperty.points.pointMouse.image === 'object' &&
              typeof item.otherProperty.points.pointMouse.image.src === 'string'
                ? item.otherProperty.points.pointMouse.image
                : undefined,
            positions: {
              rad:
                typeof item.otherProperty.points.pointMouse === 'object' &&
                fJS.isNumeric(item.otherProperty.points.pointMouse.rad)
                  ? item.otherProperty.points.pointMouse.rad
                  : stage.defConfig.point.positions.pos.rad,
            },
            stage: stage,
          });
          stage.mousePoint.shape.visible = false;
          stage._listener.md = stage._stage.on('mousedown', stage.stageMouseDown, null, false, {
            engine: null,
            point: null,
            cjsStage: stage,
          });
          stage._listener.pu = stage._stage.on('pressup', stage.stageMouseUp, null, false, {
            engine: null,
            point: null,
            cjsStage: stage,
          });

          stage._stage.addChildAt(stage.mousePoint.shape, stage._stage.numChildren - 1);
        }
        if (Array.isArray(item.otherProperty.points.items) && item.otherProperty.points.items.length > 0) {
          for (let j = 0; j < item.otherProperty.points.items.length; j++) {
            let ptC = _.cloneDeep(stage.defConfig.point),
              ptItem = _.cloneDeep(item.otherProperty.points.items[j]);
            delete ptC.positions.pos.x;
            delete ptC.positions.pos.y;
            delete ptC.registrationPoint.x;
            delete ptC.registrationPoint.y;
            if (
              typeof item.otherProperty.points.itemsConfig === 'object' &&
              item.otherProperty.points.itemsConfig !== null
            ) {
              ptC = _.merge(ptC, item.otherProperty.points.itemsConfig);
            }
            if (typeof ptItem === 'object' && ptItem !== null) {
              ptC = _.merge(ptC, ptItem);
            }

            if (
              typeof ptC.positions.pos === 'object' &&
              typeof ptC.positions.pos.setTo === 'string' &&
              (!fJS.isNumeric(ptC.positions.pos.x) || !fJS.isNumeric(ptC.positions.pos.y))
            ) {
              cjsPoint.prototype.setPosXYfromSetTo(ptC.positions.pos, item);
              if (!fJS.isNumeric(ptC.positions.pos.x)) ptC.positions.pos.x = stage.defConfig.point.positions.pos.x;
              if (!fJS.isNumeric(ptC.positions.pos.y)) ptC.positions.pos.y = stage.defConfig.point.positions.pos.y;
            }

            if (
              typeof ptC.registrationPoint === 'object' &&
              typeof ptC.registrationPoint.setTo === 'string' &&
              (!fJS.isNumeric(ptC.registrationPoint.x) || !fJS.isNumeric(ptC.registrationPoint.y))
            ) {
              cjsPoint.prototype.setPosXYfromSetTo(ptC.registrationPoint, item);
              if (!fJS.isNumeric(ptC.registrationPoint.x))
                ptC.registrationPoint.x = stage.defConfig.point.registrationPoint.x;
              if (!fJS.isNumeric(ptC.registrationPoint.y))
                ptC.registrationPoint.y = stage.defConfig.point.registrationPoint.y;
            }

            let nPt = new cjsPoint(
              _.merge(ptC, {
                //   id: item.id,
                //   name: item.name,
                stage: stage,
                idGroup: gr,
                idItem: i,
              })
            );
            item._addPoint(nPt);
          }
        }
      }

      if (typeof item.container.idGroup !== 'string') item.container.idGroup = gr;
      if (typeof item.container.idItem !== 'string') item.container.idItem = i;

      item.container.children.forEach(function(child) {
        if (typeof child.idGroup !== 'string') child.idGroup = gr;
        if (typeof child.idItem !== 'string') child.idItem = i;
      });
    }
  }

  if (typeof stage.mousePoint === 'object' && stage.mousePoint !== null) {
    stage._stage.setChildIndex(stage.mousePoint.shape, stage._stage.getNumChildren() - 1);
  }

  stage.update();
};

cjsItem.afterPromises = function(stage) {
  console.log('cjsItem: afterPromises');

  for (let gr in stage.groups) {
    for (let i in stage.groups[gr].items) {
      let item = stage.groups[gr].items[i];
      let p = { x1: false, x2: false, y1: false, y2: false };
      stage.getMeasure(p, item._container);
      item._container.cache(p.x1, p.y1, p.x2 - p.x1, p.y2 - p.y1);
      item._container.cacheMeasure = _.cloneDeep(p);
    }
    if (stage.groups[gr].container.cacheID !== 0) stage.groups[gr].container.uncache();
    let p = { x1: false, x2: false, y1: false, y2: false };
    stage.getMeasure(p, stage.groups[gr]._container);
    stage.groups[gr]._container.cacheMeasure = _.cloneDeep(p);
  }
  stage.update();
  console.log(stage.groups);
};

export class DynamicClass {
  constructor(className, opts) {
    return new games[className](opts);
  }

  fn(className, name, opts) {
    if (games[className][name] === undefined) {
      return -1;
    }
    return games[className][name].call(this, opts);
  }
}
